// extracted by mini-css-extract-plugin
export default {"screen":"screen__02d482a3","statistic-item":"statistic-item__10072562"};